import { cn } from "~/lib/utils";

interface Props {
  category?: string | null;
  type?: string | null;
  className?: string;
}

export const ActionBadge = ({ category, type, className }: Props) => {
  // We use category as the primary driver for color, with a fallback to type or "Task"
  const label = category || type || "Task";

  // Map category/type to a specific color palette
  const getColorClasses = (val: string) => {
    switch (val) {
      case "Correction":
      case "CorrectiveAction":
      case "CAPA":
        return "bg-amber-50 text-amber-700 border-amber-200";
      case "Emergency":
        return "bg-red-50 text-red-700 border-red-200";
      case "Mitigation":
        return "bg-purple-50 text-purple-700 border-purple-200";
      case "Remediation":
        return "bg-emerald-50 text-emerald-700 border-emerald-200";
      case "Verification":
        return "bg-teal-50 text-teal-700 border-teal-200";
      case "Task":
      case "GeneralTask":
      default:
        return "bg-blue-50 text-blue-700 border-blue-200";
    }
  };

  const getLabel = (val: string) => {
    if (val === "CorrectiveAction") return "CAPA";
    if (
      val === "GeneralTask" ||
      val === "WorkHoursTask" ||
      val === "AuditAssignment" ||
      val === "InspectionAssignment"
    ) {
      return "Task";
    }
    return val;
  };

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium border",
        getColorClasses(label),
        className,
      )}
    >
      {getLabel(label)}
    </span>
  );
};
